module.exports = "<app-kiosk-edit-tenants *ngIf=\"kiosk\" [tenants]=\"kiosk.tenants\" (tenantsChanged)=\"tenantsChanged($event)\">\n</app-kiosk-edit-tenants>\n\n<button mat-raised-button (click)=\"saveTenants()\" [disabled]=\"loading || tenants.length === 0\">Save </button>\n<app-loader [isLoading]=\"loading\" style=\"display:inline-block\"></app-loader>"


//////////////////
// WEBPACK FOOTER
// ./src/app/kiosk-edit-tenant-dialog/kiosk-edit-tenant-dialog.component.html
// module id = ./src/app/kiosk-edit-tenant-dialog/kiosk-edit-tenant-dialog.component.html
// module chunks = main